/** @format */

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { PaymentDeadlineCodeCollectionInterface } from '../../interfaces/collections/PaymentDeadlineCodeCollectionInterface';
import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';
import { PaymentDeadlineCode } from '../../interfaces/platform/PaymentDeadlineCode';
import { PaymentDeadlineCodeLoader } from '../../modules/paymentDeadlineCode/paymentDeadlineCodeLoader';
import { SimpleSelect } from './SimpleSelect';
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';

interface PaymentDeadlineCodeSelectPropsInterface {
    label: string;
    required: boolean;
    selectedValue: number | undefined;
    callback?: (e: any) => void;
}

export const PaymentDeadlineCodeSelect = (props: PaymentDeadlineCodeSelectPropsInterface): React.ReactElement => {
    const [filters, setFilters] = useState<Array<Filter>>([]);
    const [orders, setOrders] = useState<Array<Order>>([]);
    const [paymentCodes, setPaymentCodes] = useState<PaymentDeadlineCodeCollectionInterface | null>(null);
    const dispatch = useDispatch();

    const itemLoaders = useMemo(() => {
        return new ItemLoaders(dispatch);
    }, [dispatch]);

    const paymentDeadlineCodeLoader = useMemo(() => {
        return new PaymentDeadlineCodeLoader(itemLoaders);
    }, [itemLoaders]);

    const testCodes = useCallback((): void => {
        setPaymentCodes(paymentDeadlineCodeLoader.getPaymentDeadLineCodes());
    }, [paymentDeadlineCodeLoader]);

    const prepareSimpleSelectElements = (): Array<HeaderCheckBoxSelectListElement> => {
        if (!paymentCodes) {
            return [];
        }
        const mappedValues = paymentCodes['hydra:member'].map((el: PaymentDeadlineCode) => {
            return { name: `${el.code} - ${el.mainname}`, value: el.id };
        });
        return mappedValues;
    };

    useEffect(() => {
        paymentDeadlineCodeLoader.loadPaymentDeadlineCodes(filters, orders, testCodes);
    }, [dispatch, filters, orders, paymentDeadlineCodeLoader, testCodes]);

    return (
        <SimpleSelect
            label={props.label}
            required={props.required}
            elements={prepareSimpleSelectElements()}
            callback={props.callback}
            dispatchName={'test'}
            selectedValue={props.selectedValue}
        />
    );
};
